import { Controller } from "@hotwired/stimulus"
import getCsrfToken from "../utils/csrf";

export default class extends Controller {
    static targets = ["checkBoxWrapper"];

    connect() {}

    advancedConfirmClick(event) {
        event.preventDefault();
        const target = event.currentTarget;
        const link = target.dataset.link;
        const confirmation = target.dataset.advancedConfirm;
        const isActive = target.dataset.isActive === "true";
        const isActiveUrl = target.dataset.isActiveUrl;
        const isComplete = target.dataset.isComplete === "true";

        if (isActive) {
            Turbolinks.visit(link);
            return;
        }

        if (confirm(confirmation)) {
            if (isComplete) {
                fetch(isActiveUrl, {
                    method: 'PUT',
                    headers: {
                        'Content-Type': 'application/json',
                        'X-CSRF-Token': getCsrfToken()
                    },
                    body: JSON.stringify({
                        v2_edit: true,
                        building_building: {
                            is_active: true
                        }
                    })
                })
                    .then(response => response.json())
                    .finally(() => {
                        Turbolinks.visit(link);
                    });
            }
            const checkbox = this.checkBoxWrapperTarget;
            if (checkbox) {
                checkbox.click();
                return;
            }
        } else {
            Turbolinks.visit(link);
        }
    }
}
